import React, { useState } from "react";
import { Helmet } from "react-helmet";
import { appName } from "../../../app.json";
import AlertMessage from "../../../partials/alertMessage";
import LoadingSpinner from "../../../partials/loading";
import auth from "../../../providers/Auth.Provider";
import SubFilter from "./Filter";
import NewSubscriptionForm from "./NewSubscription";
import SubscriptionList from "./ListSubs";
import { GET_SUBS, NEW_SUB } from "../../../queries/subscription.query";
import { useQuery, useMutation } from "@apollo/react-hooks";
import { Redirect } from "react-router-dom";
import Pagination from "../../../partials/pagination";

const Subscription = ({ match, location }) => {
	const [newSub, setNewSub] = useState(false);
	const [page] = useState(1);
	const [limit] = useState(25);
	// props
	const title = "Services Subscription";
	
	const { loading, data, error, refetch, fetchMore } = useQuery(GET_SUBS, {
		variables: { page, limit }
	});

	const [
		CreateNewSub,
		{ loading: nLoading, data: nData, error: nError }
	] = useMutation(NEW_SUB, {
		update(caches, { data: { SubscribeToService } }) {
			const { GetServiceSubscribers } = caches.readQuery({
				query: GET_SUBS,
				variables: { page, limit }
			});

			GetServiceSubscribers.docs.unshift(SubscribeToService.doc);

			caches.writeQuery({
				variables: { page, limit },
				query: GET_SUBS,
				data: { GetServiceSubscribers }
			});
		}
	});

	const { LogOut, IsAuthenticationError } = auth.authProvider;
	if (
		(error && IsAuthenticationError(error.message)) ||
		(nError && IsAuthenticationError(nError.message))
	) {
		LogOut();
		return (
			<Redirect
				to={{
					pathname: "/login",
					search: `?redirect=${location.pathname}`
				}}
			/>
		);
	}

	return (
		<>
			<Helmet>
				<title>
					{title} | {appName}
				</title>
			</Helmet>

			<div className="row justify-content-center">
				{newSub && (
					<div className="col-md-8 fade-in">
						<div className="card">
							<div className="card-head">
								<header>New Service Subscription Form</header>
							</div>
							<div className="card-body m-b-20">
								<LoadingSpinner loading={nLoading} />
								<AlertMessage
									message={nError && nError.message}
									failed={true}
								/>
								<AlertMessage
									message={
										nData &&
										nData.SubscribeToService.message
									}
								/>
								<NewSubscriptionForm
									parents={
										data && data.GetManyParentSite.docs
									}
									onCancel={() => setNewSub(false)}
									onSubmit={async model => {
										await CreateNewSub({
											variables: { model }
										});
									}}
								/>
							</div>
						</div>
					</div>
				)}
				{!newSub && (
					<div className="col-md-12 fade-in">
						<div className="card">
							<div className="card-head">
								<header>
									<i className="fa fa-filter"></i> Filter
								</header>
								<div className="tools">
									<div className="tools">
										<a
											className="t-collapse btn-color fa fa-chevron-down"
											href="javascript:;"
										></a>
									</div>
								</div>
							</div>
							<div className="card-body m-b-10">
								<SubFilter
									onFilter={({ dateRange }) => {
										refetch({ variables: { dateRange } });
									}}
								/>
							</div>
							<div className="card-footer text-right m-b-10">
								<button
									type="button"
									onClick={() => {
										setNewSub(!newSub);
										document.body.scrollTop = 0;
										document.documentElement.scrollTop = 0;
									}}
									className="mdl-button mdl-button--raised mdl-js-ripple-effect btn-circle btn-success"
								>
									<i className="material-icons">
										attach_money
									</i>{" "}
									New Subscription
								</button>
							</div>
						</div>
					</div>
				)}

				<div className="col-md-12">
					<div className="card">
						<div className="card-head">
							<header>
								<i className="fa fa-money"></i> {title}
							</header>
							<div className="tools">
								<div className="tools">
									<a
										className="t-collapse btn-color fa fa-chevron-down"
										href="javascript:;"
									></a>
								</div>
							</div>
						</div>
						<div className="card-body">
							<AlertMessage
								message={error && error.message}
								failed={true}
							/>
							<LoadingSpinner loading={loading} />
							<SubscriptionList
								items={data && data.GetServiceSubscribers.docs}
							/>
						</div>
						{data && (
							<Pagination
								length={data.GetServiceSubscribers.docs.length}
								{...data.GetServiceSubscribers}
								onPageClicked={page =>
									fetchMore({
										variables: { page },
										updateQuery: (prev, { newResult }) => {
											if (!newResult) return prev;
											return {
												GetServiceSubscribers:
													newResult.GetServiceSubscribers
											};
										}
									})
								}
							/>
						)}
					</div>
				</div>
			</div>
		</>
	);
};

export default Subscription;
